import React from 'react'
import { Link } from "react-router-dom";
import './index.css'
import { Row, Col, Card, Flex, Collapse, Typography, Button, Space, Image } from 'antd'
import { EnvironmentOutlined } from '@ant-design/icons'
const { Title, Text, Paragraph } = Typography;
const Findprofessionlayout = () => {
    const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

    const items = [
        {
            key: '1',
            label: 'This is panel header 1',
            children: <p>{text}</p>,
        },
        {
            key: '2',
            label: 'This is panel header 2',
            children: <p>{text}</p>,
        },
        {
            key: '3',
            label: 'This is panel header 3',
            children: <p>{text}</p>,
        },
    ];

    const cardData = [
        {
            key: '1',
            profileimg: 'profile1.webp',
            username: 'Dynamic Solution',
            skilldesc:'UI design for your app and website',
            skillset:[
                {
                    key:1,
                    skill:'Figma'
                },
                {
                    key:2,
                    skill:'UI & UX Design'
                },
                {
                    key:3,
                    skill:'Website UI & UX Design'
                }
            ],
            location: 'Pakistan',

        },
    ]
    return (
        <div className=''>
            <div className='container'>
                <Row gutter={[16, 16]}>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                        <Card className='shadow-c filter-sidebar rounded0 py-2'>
                            <Flex vertical className='w-100'>
                                <Title level={4} className=''>
                                    Filter your search
                                </Title>
                                <Collapse items={items} defaultActiveKey={['1']} />
                            </Flex>
                        </Card>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 18 }} lg={{ span: 18 }} xl={{ span: 18 }}>
                        <div className=''>
                            <Flex vertical gap={10}>
                                {
                                    cardData?.map((data, index) => (
                                       <Link>
                                        <Card className='jobcard border0 shadow-c'>
                                            <Row gutter={[16, 16]} align={'middle'}>
                                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 18 }} lg={{ span: 18 }}>
                                                    <Flex gap={5} align='' className='mt-2'>
                                                        <Image src={'assets/images/'+ data?.profileimg} width={45} height={45} preview={false} />

                                                        <Flex vertical className=''>
                                                            <Title level={4} className='m-0'>{data?.username}</Title>
                                                            <Text>{data?.skilldesc}</Text>
                                                            <Text><EnvironmentOutlined />{data?.location}</Text>
                                                            <Space>
                                                                {/* {
                                                                    cardData?.skillset.map((skl))
                                                                } */}
                                                            <span className='custom-badge fs-12 border-black'>Skills</span>
                                                            </Space>
                                                            <Flex className='mt-2'>
                                                                <Button className="btn fs-14 fw-400 p-2">Apply Now</Button>
                                                            </Flex>

                                                        </Flex>
                                                    </Flex>

                                                </Col>
                                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }}>

                                                    <Flex vertical align='center' gap={10}>
                                                        <Text>{data?.postdate}</Text>
                                                        <Image src='assets/icons/heart.png' width={30} height={30} preview={false} />
                                                    </Flex>
                                                </Col>
                                            </Row>
                                        </Card>
                                       </Link>
                                    ))
                                }

                            </Flex>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export { Findprofessionlayout }